<template>
  <section v-if="!loading && items.length">
    <v-container>
      <TitleWidget>
        {{ title }}
      </TitleWidget>

      <div class="mt-8 mt-md-10 grid-list">
        <template v-for="(item, keyItems) in items">
          <ArticleCard
            :class="[keyItems === 0 ? 'article-big' : 'article-small']"
            :key="keyItems"
            :small="keyItems > 0"
            v-bind="item"
          />
        </template>
      </div>

      <ButtonWidget
        class="mt-8 mt-md-10"
        :to="path"
        color="primary"
        text-color="white"
        align="center"
        outlined
      >
        Ver Mais
      </ButtonWidget>
    </v-container>
  </section>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
import ArticleCard from "../cards/ArticleCard.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";
import { formatToURL } from "../../utils/formatToURL";

const _config = {
  mod: "articles",
  path: "/noticias",
};

const _pagination = {
  itemsPerPage: 3,
};

const _data = {
  loading: true,
  title: "Notícias",
  path: _config.path,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(({ id, img, title, date }) => ({
        img,
        title,
        date,
        to: `${_config.path}/${formatToURL(title)}-${id}`,
      }));
    },
  },
  methods: {
    getList() {
      this.loading = true;

      const params = { ..._pagination };

      this.$rest(_config.mod)
        .get({ params })
        .finally(() => (this.loading = false));
    },
  },
  watch: {
    "$route.path"() {
      this.getList();
    },
  },
  created() {
    this.getList();
  },
  components: {
    TitleWidget,
    ArticleCard,
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.parent {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 24px;
  grid-row-gap: 24px;
}

.grid-list {
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);

  @media screen and (max-width: 959.9px) {
    gap: 12px;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
  }

  @media screen and (max-width: 599.9px) {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 1fr);
  }

  .article-big {
    grid-area: 1 / 1 / 3 / 3;

    @media screen and (max-width: 599.9px) {
      grid-area: 1 / 1 / 2 / 2;
    }
  }

  .article-small {
    &:nth-child(0) {
      grid-area: 1 / 3 / 2 / 4;

      @media screen and (max-width: 959.9px) {
        grid-area: 3 / 1 / 4 / 2;
      }

      @media screen and (max-width: 599.9px) {
        grid-area: 2 / 1 / 3 / 2;
      }
    }

    &:nth-child(1) {
      grid-area: 2 / 3 / 3 / 4;

      @media screen and (max-width: 959.9px) {
        grid-area: 3 / 2 / 4 / 3;
      }

      @media screen and (max-width: 599.9px) {
        grid-area: 3 / 1 / 4 / 2;
      }
    }
  }
}
</style>
